import { render, staticRenderFns } from "./MakeActiveButton.vue?vue&type=template&id=46a99c37&scoped=true"
import script from "./MakeActiveButton.vue?vue&type=script&lang=js"
export * from "./MakeActiveButton.vue?vue&type=script&lang=js"
import style0 from "./MakeActiveButton.vue?vue&type=style&index=0&id=46a99c37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a99c37",
  null
  
)

export default component.exports